import { React, useEffect, useState } from "react";
import { Box, Grid, Typography, Button } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import CustomInput from "../../CustomInput/CustomInput";
import { useDispatch, useSelector } from "react-redux";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import * as Yup from "yup";
import {
  setAgentSignupData,
  setAgentSignupStepCount,
} from "../../../redux/login";
import {
  setOpenAgentLoginFlow,
  setOpenAgentSignupFlow,
} from "../../../redux/login";
import InputAdornment from "@mui/material/InputAdornment";
import { ReactComponent as EyeIcon } from "../../../assets/svg/visible.svg";
import { ReactComponent as OffEyeIcon } from "../../../assets/svg/invisible.svg";
import province from "../../../json/Province.json";
import district from "../../../json/District.json";
import neighbourhood from "../../../json/Neighbourhood.json";
import BankList from "../../../json/BankList.json";
import { loginItemsSelector } from "../../../redux/login";

const AgentSignUp = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { agentSignUpData } = useSelector(loginItemsSelector);
  const [agentRegistrationData, setAgentRegistrationData] = useState();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [type, setType] = useState("password");
  const [confirmType, setConfirmType] = useState("password");
  const [selectedState, setSelectedState] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedNeighborhood, setSelectedNeighborhood] = useState("");
  const [customNeighborhood, setCustomNeighborhood] = useState("");
  const [selectedBankName, setSelectedBankName] = useState("");
  const [customBankName, setCustomBankName] = useState("");
  const [customDistrict, setCustomDistrict] = useState("");
  const langauge = localStorage.getItem("language");
  const langParam = langauge === "pr" ? 2 : 1;
  const storedSignupData = JSON.parse(
    localStorage.getItem("agent_signup_data") || "{}",
  );
  const savedSignupData = {
    ...storedSignupData,
    ...(agentSignUpData?.items || {}),
  };

  const { t } = useTranslation();
  const handleToggle = () => {
    if (type === "password") {
      //  setIcon(eye);
      setType("text");
    } else {
      //  setIcon(eyeOff)
      setType("password");
    }
  };
  const handleConfirmPwdToggle = () => {
    if (confirmType === "password") {
      //  setIcon(eye);
      setConfirmType("text");
    } else {
      //  setIcon(eyeOff)
      setConfirmType("password");
    }
  };
  const getPasswordStrength = (pwd) => {
    if (!pwd) return { score: 0, label: '' };
    let score = 0;
    if (pwd.length >= 8) score += 1;
    if (/[A-Z]/.test(pwd)) score += 1;
    if (/[0-9]/.test(pwd)) score += 1;
    if (/[^A-Za-z0-9]/.test(pwd)) score += 1;
    const label = score <= 1 ? 'Weak' : score === 2 ? 'Fair' : score === 3 ? 'Good' : 'Strong';
    return { score, label };
  };
  const handleLogin = async (values, { resetForm }) => {
    // setAgentRegistrationData(formData);
    try {
      const mergedValues = {
        ...(agentSignUpData?.items || {}),
        ...values,
      };
      localStorage.setItem("agent_signup_data", JSON.stringify(mergedValues));
      dispatch(setAgentSignupData(mergedValues));
      dispatch(setAgentSignupStepCount(2));
    } catch (e) {
      console.log(e, "err");
      resetForm({
        first_name: "",
        middle_name: "",
        last_name: "",
        contact_number: "",
        email: "",
        password: "",
        confirm_password: "",
        neighborhood: "",
        address: "",
        city: "",
        state: "",
        country: "",
        bank_name: "",
        account_number: "",
        tax_registration: "",
        user_type: 2,
      });
    }
  };

  const formik = useFormik({
    initialValues: {
      first_name: savedSignupData.first_name || "",
      middle_name: savedSignupData.middle_name || "",
      last_name: savedSignupData.last_name || "",
      contact_number: savedSignupData.contact_number || "+258 8",
      email: savedSignupData.email || "",
      password: savedSignupData.password || "",
      confirm_password: savedSignupData.confirm_password || "",
      neighborhood: savedSignupData.neighborhood || "",
      city: savedSignupData.city || "",
      country: savedSignupData.country || "mozambique",
      address: savedSignupData.address || "",
      state: savedSignupData.state || "",
      bank_name: savedSignupData.bank_name || "",
      account_number: savedSignupData.account_number || "",
      // postal_code: "",
      tax_registration: savedSignupData.tax_registration || "",
      user_type: 2,
    },
    validationSchema: Yup.object({
      first_name: Yup.string()
        .required(t("Validation.Name is required"))
        .matches(
          "^[a-zA-Z']+[a-zA-Z'\\. ]*$",
          t("Validation.First Name must be valid")
        ),
      // middle_name:Yup.string().matches().matches(
      //   "^[a-zA-Z']+[a-zA-Z'\\. ]*$",
      //   "Middle Name must be valid"
      // ),
      // last_name:Yup.string().matches().matches(
      //   "^[a-zA-Z']+[a-zA-Z'\\. ]*$",
      //   "Last Name must be valid"
      // ),
      email: Yup.string()
        .email(t("Validation.Please enter Email"))
        .required(t("Validation.Please enter Email")),
      contact_number: Yup.string()
        // .max(18, t("Validation.Mobile Number is Invalid"))
        // .length(8, t("Validation.Mobile Number is Invalid"))
        .required(t("Validation.Mobile Number is required")),
      password: Yup.string()
        .required(t("Validation.New password is required!"))
        .min(8, t(
          "Validation.Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
        ))
        .max(128, t(
          "Validation.Password cannot exceed 128 characters"
        ))
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
          t(
            "Validation.Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
          )
        ),
      confirm_password: Yup.string()
        .required(t("Validation.Please Enter Confirm Password!"))
        .oneOf(
          [Yup.ref("password")],
          t("Validation.Both passwords need to be the same")
        ),
      neighborhood: Yup.string().required(
        t("Validation.Please enter Neighbourhood")
      ),
      city: Yup.string().required(t("Validation.Please Enter City")),
      state: Yup.string().required(t("Validation.Please Enter State")),
      address: Yup.string().required(t("Validation.Please Enter Address"))
        .matches(/^[a-zA-Z0-9\s,()\/-]+$/, (t('Validation.Please Enter valid Address'))),
      // postal_code: Yup.string().required(t("Validation.Please Enter Postal Code"))
      // .matches('^[0-9]*$',t("Validation.Postal Code is Invalid")),
      bank_name: Yup.string().required(t("Validation.Please Enter Bank Name")),

      account_number: Yup.string()
        .required(t("Validation.Please Enter Account No"))
        .min(8, t("Validation.Please Enter valid Account No"))
        .max(14, t("Validation.Please Enter valid Account No"))
        .matches("^[0-9]*$", t("Validation.Please Enter valid Account No")),
      tax_registration: Yup.string()
        .required(t("Validation.Please Enter Tax Registration No"))
        .length(9, t("Validation.Please Enter valid Tax Registration No"))
        .matches(
          "^[0-9]*$",
          t("Validation.Please Enter valid Tax Registration No")
        ),
    }),
    enableReinitialize: true,
    onSubmit: handleLogin,
  });

  useEffect(() => {
    setPassword(savedSignupData.password || "");
    setConfirmPassword(savedSignupData.confirm_password || "");
    setSelectedState(savedSignupData.state || "");
    setSelectedDistrict(savedSignupData.city || "");
    setSelectedNeighborhood(savedSignupData.neighborhood || "");
    setSelectedBankName(savedSignupData.bank_name || "");
  }, []);

  return (
    <>
      <form onSubmit={formik.handleSubmit} noValidate>
        <Box sx={{ p: { xs: 1, md: 2 }, background: '#FFFFFF' }}>
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: "1.3rem",
              color: "#1B2559",
              fontFamily: "Poppins, sans-serif",
              textAlign: 'center',
              width: '100%',
              mb: 3
            }}
          >
            {t("AgentRegistration.Agent_Registration")}
          </Typography>
          {/* <Typography
            sx={{
              fontSize: "0.875rem",
              color: "#64748B",
              textAlign: "center",
              mb: 4
            }}
          >
            Join our network of professional agents.
          </Typography> */}

          {/* Section 1: Your Details */}
          <Box sx={{ mb: 4 }}>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "1rem",
                color: "#1B2559",
                fontFamily: "Poppins, sans-serif",
                mb: 2,
                pb: 1,
                borderBottom: '1px solid #F1F5F9'
              }}
            >
              {t("AgentRegistration.YourDetails")}
            </Typography>

            <Grid container spacing={2.5}>
              <Grid item xs={10} sm={10}>
                <CustomInput
                  variant="outlined"
                  fullWidth
                  label={t("AgentRegistration.Name") + "*"}
                  placeholder={t("AgentRegistration.Name")}
                  InputLabelProps={{ shrink: true }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                  name="first_name"
                  onChange={formik.handleChange}
                  value={formik.values.first_name}
                  error={formik.touched.first_name && Boolean(formik.errors.first_name)}
                  helperText={formik.touched.first_name && formik.errors.first_name}
                />
              </Grid>
              <Grid item xs={10} sm={10}>
                <CustomInput
                  variant="outlined"
                  fullWidth
                  label={t("AgentRegistration.MiddleName")}
                  placeholder={t("AgentRegistration.MiddleName")}
                  InputLabelProps={{ shrink: true }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                  name="middle_name"
                  onChange={formik.handleChange}
                  value={formik.values.middle_name}
                />
              </Grid>
              <Grid item xs={10} sm={10}>
                <CustomInput
                  variant="outlined"
                  fullWidth
                  label={t("AgentRegistration.Surname")}
                  placeholder={t("AgentRegistration.Surname")}
                  InputLabelProps={{ shrink: true }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                  name="last_name"
                  onChange={formik.handleChange}
                  value={formik.values.last_name}
                />
              </Grid>
              <Grid item xs={10} sm={10}>
                <CustomInput
                  variant="outlined"
                  fullWidth
                  label={t("CustomerRegistration.ContactNo") + "*"}
                  placeholder={t("CustomerRegistration.ContactNo")}
                  InputLabelProps={{ shrink: true }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                  name="contact_number"
                  onKeyDown={(e) => {
                    const PREFIX = "+258 8";
                    if (
                      (e.key === "Backspace" || e.key === "Delete") &&
                      e.target.selectionStart <= PREFIX.length
                    ) {
                      e.preventDefault();
                    }
                  }}
                  onChange={(e) => {
                    const PREFIX = "+258 8";
                    const value = e.target.value;
                    if (!value.startsWith(PREFIX)) {
                      formik.setFieldValue("contact_number", PREFIX);
                      return;
                    }
                    let numericSuffix = value.slice(PREFIX.length).replace(/\D/g, "");
                    if (numericSuffix.length > 8) numericSuffix = numericSuffix.slice(0, 8);
                    formik.setFieldValue("contact_number", PREFIX + numericSuffix);
                  }}
                  value={formik.values.contact_number || "+258 8"}
                  error={formik.touched.contact_number && formik.values.contact_number.replace(/^\+258 8/, "").length !== 8}
                  helperText={formik.touched.contact_number && formik.values.contact_number.replace(/^\+258 8/, "").length !== 8 ? "Phone number must be exactly 8 digits" : ""}
                />
              </Grid>
              <Grid item xs={10} sm={10}>
                <CustomInput
                  variant="outlined"
                  fullWidth
                  label={t("LogIn.EmailAddress") + "*"}
                  placeholder={t("LogIn.EmailAddress")}
                  InputLabelProps={{ shrink: true }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                  name="email"
                  onChange={(e) => {
                    formik.handleChange(e);
                    localStorage.setItem("agentEmail", e.target.value);
                  }}
                  value={formik.values.email}
                  error={formik.touched.email && Boolean(formik.errors.email)}
                  helperText={formik.touched.email && formik.errors.email}
                />
              </Grid>
              <Grid item xs={10} sm={10}>
                <CustomInput
                  variant="outlined"
                  fullWidth
                  type={type}
                  label={t("LogIn.Password") + "*"}
                  placeholder={t("LogIn.Password")}
                  InputLabelProps={{ shrink: true }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" onClick={handleToggle} sx={{ cursor: "pointer" }}>
                        {type == "password" ? <OffEyeIcon style={{ fill: '#0085FD', height: '26px', width: '26px' }} /> : <EyeIcon style={{ fill: '#0085FD', height: '26px', width: '26px' }} />}
                      </InputAdornment>
                    ),
                  }}
                  name="password"
                  onChange={(e) => { formik.handleChange(e); setPassword(e.target.value); }}
                  value={formik.values.password}
                  error={formik.touched.password && Boolean(formik.errors.password)}
                  helperText={formik.touched.password && formik.errors.password}
                />
                {password ? (
                  <Box sx={{ mt: 1 }}>
                    <Box sx={{ height: 6, background: '#E6E6E6', borderRadius: 2, overflow: 'hidden' }}>
                      <Box sx={{
                        height: '100%',
                        width: `${(getPasswordStrength(password).score / 4) * 100}%`,
                        background: getPasswordStrength(password).score <= 1 ? '#ff4d4f' : getPasswordStrength(password).score === 2 ? '#faad14' : getPasswordStrength(password).score === 3 ? '#52c41a' : '#237804',
                        borderRadius: 2,
                        transition: 'width .2s ease'
                      }} />
                    </Box>
                    <Typography variant="xxsSize" className="font-w-400 gray-color" sx={{ mt: 0.5 }}>{getPasswordStrength(password).label}</Typography>
                  </Box>
                ) : null}
              </Grid>
              <Grid item xs={10} sm={10}>
                <CustomInput
                  variant="outlined"
                  type={confirmType}
                  fullWidth
                  label={t("CustomerRegistration.ConfirmPwd") + "*"}
                  placeholder={t("CustomerRegistration.ConfirmPwd")}
                  InputLabelProps={{ shrink: true }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" onClick={handleConfirmPwdToggle} sx={{ cursor: "pointer" }}>
                        {confirmType == "password" ? <OffEyeIcon style={{ fill: '#0085FD', height: '26px', width: '26px' }} /> : <EyeIcon style={{ fill: '#0085FD', height: '26px', width: '26px' }} />}
                      </InputAdornment>
                    ),
                  }}
                  name="confirm_password"
                  onChange={formik.handleChange}
                  value={formik.values.confirm_password}
                  error={formik.touched.confirm_password && Boolean(formik.errors.confirm_password)}
                  helperText={formik.touched.confirm_password && formik.errors.confirm_password}
                />
              </Grid>
            </Grid>
          </Box>

          {/* Section 2: Address */}
          <Box sx={{ mb: 4 }}>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "1rem",
                color: "#1B2559",
                fontFamily: "Poppins, sans-serif",
                mb: 2,
                pb: 1,
                borderBottom: '1px solid #F1F5F9'
              }}
            >
              {t("AgentRegistration.Address")}
            </Typography>

            <Grid container spacing={2.5}>
              <Grid item xs={10} sm={10}>
                <CustomInput
                  variant="outlined"
                  fullWidth
                  label={t("AgentRegistration.Address") + "*"}
                  placeholder={t("AgentRegistration.Address")}
                  InputLabelProps={{ shrink: true }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                  name="address"
                  onChange={formik.handleChange}
                  value={formik.values.address}
                  error={formik.touched.address && Boolean(formik.errors.address)}
                  helperText={formik.touched.address && formik.errors.address}
                />
              </Grid>
              <Grid item xs={10} sm={10}>
                <CustomInput
                  variant="outlined"
                  fullWidth
                  label={t("AgentRegistration.State") + "*"}
                  placeholder={t("AgentRegistration.State")}
                  onChange={(e) => {
                    formik.handleChange(e);
                    setSelectedState(e.target.value);
                  }}
                  InputLabelProps={{ shrink: true }}
                  SelectProps={{ native: true }}
                  select
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                  value={formik.values.state}
                  name="state"
                  error={formik.touched.state && Boolean(formik.errors.state)}
                  helperText={formik.touched.state && formik.errors.state}
                >
                  <option value="">{t("PostProperty.Select Options")}</option>
                  {province?.map((data, id) => (
                    <option key={id} value={langParam === 1 ? data?.label : data?.label_pr}>
                      {langParam === 1 ? data?.label : data?.label_pr}
                    </option>
                  ))}
                </CustomInput>
              </Grid>
              <Grid item xs={10} sm={10}>
                <CustomInput
                  variant="outlined"
                  fullWidth
                  label={t("AgentRegistration.City") + "*"}
                  placeholder={t("AgentRegistration.City")}
                  onChange={(e) => {
                    const value = e.target.value;
                    setSelectedDistrict(value);
                    formik.setFieldValue("city", (value === "Other" || value === "Outro") ? "" : value);
                  }}
                  InputLabelProps={{ shrink: true }}
                  SelectProps={{ native: true }}
                  select
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                  value={selectedDistrict || formik.values.city}
                  name="city"
                  error={formik.touched.city && Boolean(formik.errors.city)}
                  helperText={formik.touched.city && formik.errors.city}
                >
                  <option value="">{t("PostProperty.Select Options")}</option>
                  {district[selectedState]?.map((data, id) => (
                    <option key={id} value={langParam === 1 ? data?.label : data?.label_pr}>
                      {langParam === 1 ? data?.label : data?.label_pr}
                    </option>
                  ))}
                  <option value={langParam === 1 ? "Other" : "Outro"}>{t("Agent_dashboard.Other")}</option>
                </CustomInput>
              </Grid>

              {(selectedDistrict === "Other" || selectedDistrict === "Outro") && (
                <Grid item xs={10} sm={10}>
                  <CustomInput
                    variant="outlined"
                    fullWidth
                    label={t("AgentRegistration.City") + "*"}
                    placeholder={t("Agent_dashboard.Type here")}
                    InputLabelProps={{ shrink: true }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                    name="custom_district"
                    onChange={(e) => {
                      setCustomDistrict(e.target.value);
                      formik.setFieldValue("city", e.target.value);
                    }}
                    value={customDistrict}
                  />
                </Grid>
              )}

              <Grid item xs={10} sm={10}>
                <CustomInput
                  variant="outlined"
                  fullWidth
                  label={t("AgentRegistration.Neighbourhood") + "*"}
                  placeholder={t("AgentRegistration.Neighbourhood")}
                  onChange={(e) => {
                    const value = e.target.value;
                    setSelectedNeighborhood(value);
                    formik.setFieldValue("neighborhood", (value === "Other" || value === "Outro") ? "" : value);
                  }}
                  InputLabelProps={{ shrink: true }}
                  SelectProps={{ native: true }}
                  select
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                  value={selectedNeighborhood || formik.values.neighborhood}
                  name="neighborhood"
                  error={formik.touched.neighborhood && Boolean(formik.errors.neighborhood)}
                  helperText={formik.touched.neighborhood && formik.errors.neighborhood}
                >
                  <option value="">{t("PostProperty.Select Options")}</option>
                  {neighbourhood[selectedState]?.map((data, id) => (
                    <option key={id} value={langParam === 1 ? data?.label : data?.label_pr}>
                      {langParam === 1 ? data?.label : data?.label_pr}
                    </option>
                  ))}
                  <option value={langParam === 1 ? "Other" : "Outro"}>{t("Agent_dashboard.Other")}</option>
                </CustomInput>
              </Grid>

              {(selectedNeighborhood === "Other" || selectedNeighborhood === "Outro") && (
                <Grid item xs={10} sm={10}>
                  <CustomInput
                    variant="outlined"
                    fullWidth
                    label={t("AgentRegistration.Neighbourhood") + "*"}
                    placeholder={t("Agent_dashboard.Type here")}
                    InputLabelProps={{ shrink: true }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                    name="custom_neighborhood"
                    onChange={(e) => {
                      setCustomNeighborhood(e.target.value);
                      formik.setFieldValue("neighborhood", e.target.value);
                    }}
                    value={customNeighborhood}
                  />
                </Grid>
              )}

              <Grid item xs={10} sm={10}>
                <CustomInput
                  variant="outlined"
                  fullWidth
                  disabled
                  label={t("AgentRegistration.Country") + "*"}
                  placeholder={t("AgentRegistration.Country")}
                  InputLabelProps={{ shrink: true }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px', bgcolor: '#F8FAFC' } }}
                  name="country"
                  value={"Mozambique"}
                />
              </Grid>
            </Grid>
          </Box>

          {/* Section 3: Bank Details */}
          <Box sx={{ mb: 4 }}>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "1rem",
                color: "#1B2559",
                fontFamily: "Poppins, sans-serif",
                mb: 2,
                pb: 1,
                borderBottom: '1px solid #F1F5F9'
              }}
            >
              {t("AgentRegistration.BankDetail")}
            </Typography>

            <Grid container spacing={2.5}>
              <Grid item xs={10} sm={10}>
                <CustomInput
                  variant="outlined"
                  fullWidth
                  label={t("AgentRegistration.BankName") + "*"}
                  placeholder={t("AgentRegistration.BankName")}
                  onChange={(e) => {
                    const value = e.target.value;
                    setSelectedBankName(value);
                    formik.setFieldValue("bank_name", (value === "others") ? "" : value);
                  }}
                  InputLabelProps={{ shrink: true }}
                  SelectProps={{ native: true }}
                  select
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                  value={selectedBankName || formik.values.bank_name}
                  name="bank_name"
                  error={formik.touched.bank_name && Boolean(formik.errors.bank_name)}
                  helperText={formik.touched.bank_name && formik.errors.bank_name}
                >
                  <option value="">{t("PostProperty.Select Options")}</option>
                  {BankList.banks.map((bank) => (
                    <option key={bank.id} value={bank.label === "others" ? "others" : bank.label}>
                      {bank.label === "others" ? t("PostProperty.Other") : bank.label}
                    </option>
                  ))}
                </CustomInput>
              </Grid>

              {selectedBankName === "others" && (
                <Grid item xs={10} sm={10}>
                  <CustomInput
                    variant="outlined"
                    fullWidth
                    label={"Bank Name*"}
                    placeholder={"Type Bank Name..."}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                    onChange={(e) => {
                      setCustomBankName(e.target.value);
                      formik.setFieldValue("bank_name", e.target.value);
                    }}
                    value={customBankName}
                  />
                </Grid>
              )}

              <Grid item xs={10} sm={10}>
                <CustomInput
                  variant="outlined"
                  fullWidth
                  label={t("AgentRegistration.Account_no") + "*"}
                  placeholder={t("AgentRegistration.Type_Here")}
                  InputLabelProps={{ shrink: true }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                  name="account_number"
                  onChange={formik.handleChange}
                  value={formik.values.account_number}
                  error={formik.touched.account_number && Boolean(formik.errors.account_number)}
                  helperText={formik.touched.account_number && formik.errors.account_number}
                />
              </Grid>
              <Grid item xs={10} sm={10}>
                <CustomInput
                  variant="outlined"
                  fullWidth
                  label={t("AgentRegistration.TaxRegistation") + "*"}
                  placeholder={t("AgentRegistration.Type_Here")}
                  InputLabelProps={{ shrink: true }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                  name="tax_registration"
                  onChange={formik.handleChange}
                  value={formik.values.tax_registration}
                  error={formik.touched.tax_registration && Boolean(formik.errors.tax_registration)}
                  helperText={formik.touched.tax_registration && formik.errors.tax_registration}
                />
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ mt: 5 }}>
            <Button
              type="submit"
              variant="contained"
              disableElevation
              fullWidth
              sx={{
                bgcolor: "#0085FD",
                color: "white",
                py: 1.5,
                borderRadius: "12px",
                textTransform: 'none',
                fontSize: '1rem',
                fontWeight: 700,
                fontFamily: 'Poppins, sans-serif',
                boxShadow: '0px 10px 20px rgba(0, 133, 253, 0.2)',
                "&:hover": {
                  bgcolor: "#0072DB",
                  boxShadow: '0px 12px 24px rgba(0, 133, 253, 0.3)',
                },
                mb: 2
              }}
            >
              Save & Next
            </Button>

            <Typography sx={{ textAlign: 'center', fontSize: '0.875rem', color: '#64748B', fontFamily: 'Poppins, sans-serif' }}>
              {t("CustomerRegistration.HaveAnAccount")}{" "}
              <Box
                component="span"
                onClick={() => {
                  dispatch(setOpenAgentSignupFlow(false));
                  dispatch(setOpenAgentLoginFlow(true));
                }}
                sx={{
                  color: "#0085FD",
                  fontWeight: 600,
                  cursor: "pointer",
                  fontFamily: 'Poppins, sans-serif',
                  '&:hover': { textDecoration: 'underline' }
                }}
              >
                {t("CustomerRegistration.HaveAnAccountLogin")}
              </Box>
            </Typography>
          </Box>
        </Box>
      </form>
    </>
  );
};
export default AgentSignUp;
